export default __webpack_public_path__ + "static/media/fNeutral2.315b0c74.png";